<template>
  <div v-if="entity">
    <v-alert :value="true" type="error"
      >WARNING: Do not edit this record unless you know what you are doing.
      Changing this record could affect other places in the system where it is
      in use.</v-alert
    >
    <v-alert :value="true" type="warning">
      This record is built over time to store data on a particular entity
      (person or company). For example do not change Mr Smith into Mr Brown. If
      you want to add a NEW entity go to the file and add one to the address
      book.
    </v-alert>
    <v-alert :value="true" type="info"
      >Subject properties can be edited here, where they change on a
      matter</v-alert
    >
    <h2>{{ entity.type.name }}</h2>
    <Person
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.person"
      id="personName"
    />
    <Dob
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.person"
      id="personDob"
    />
    <Company
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.company"
      id="companyName"
    />
    <Group
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.company && entity.type.groups"
      id="companyGroup"
    />
    <v-card v-if="showClient || $keycloak.hasRealmRole('root')">
      <v-card-text>
        <h2>Miscellaneous</h2>
        <div v-if="$keycloak.hasRealmRole('root')">
          <span v-if="!entity.archived" class="entityUnarchived"
            >Unarchived</span
          >&#160;
          <a v-if="!entity.archived" @click="archiveEntity(true)">Archive</a>
          <span v-if="entity.archived" class="entityArchived">{{
            entity.archived
          }}</span
          >&#160;
          <a v-if="entity.archived" @click="archiveEntity(false)">Unarchive</a>
        </div>
        <div v-if="showClient">
          <v-select
            label="Generate quote"
            v-model="quoteTypeId"
            :items="quoteTypes"
            item-value="id"
            item-text="name"
            @change="generateQuote"
            outline
            prepend-icon="shopping_cart"
          />
        </div>
        <div v-if="showClient">
          <v-btn
            :to="{ name: 'customer', params: { id: $route.params.id } }"
            small
          >
            <v-icon>credit_card</v-icon>Payments
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
    <Fee :entity="entity" @triggerUpdate="triggerUpdate" v-if="allowedFee" />
    <Address
      :entity="entity"
      :lastUpdated="lastUpdated"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.address > 0"
      id="entityAddress"
    />
    <Contact
      :entity="entity"
      :lastUpdated="lastUpdated"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.contact"
      id="entityContact"
    />
    <PanelNumber
      :entity="entity"
      :lastUpdated="lastUpdated"
      @triggerUpdate="triggerUpdate"
      v-if="allowedPanelNumbers"
      id="entityPanelNumbers"
    />
    <Uploads
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="entity.uploadEntities"
      id="entityUploads"
    />
    <Device :entity="entity" v-if="entity.devices" />
    <Security
      :entity="entity"
      :lastUpdated="lastUpdated"
      @triggerUpdate="triggerUpdate"
      v-if="entity.type.security && $keycloak.hasRealmRole('directoryadmin')"
      id="entitySecurity"
    />
    <div>{{ `security : ${entity.type.security}` }}</div>
    {{ `directory admin : ${$keycloak.hasRealmRole("directoryadmin")}` }}
    <RelatedEmployees
      :entity="entity"
      :lastUpdated="lastUpdated"
      v-if="entity.type.employees"
      id="entityRelatedEmployees"
    />
    <RelatedEmployers
      :entity="entity"
      :lastUpdated="lastUpdated"
      v-if="entity.type.id == 16"
      id="entityRelatedEmployers"
    />
    <RelatedEntities
      :entity="entity"
      v-if="entity.relatedEntities"
      id="entityRelatedEntities"
    />
    <RelatedFiles
      :entity="entity"
      v-if="entity.relatedFiles"
      id="entityRelatedFiles"
    />
    <Roles
      :entity="entity"
      :lastUpdated="lastUpdated"
      @triggerUpdate="triggerUpdate"
      v-if="entity.userRoles"
      id="entityRoles"
    />
    <Staff
      :entity="entity"
      :allowedStaff="allowedStaff"
      :allowedStaffModule="allowedStaffModule"
      v-if="allowedStaff || allowedStaffModule"
    />
    <RawData
      :entity="entity"
      @triggerUpdate="triggerUpdate"
      v-if="allowedRawData"
      id="entityRawData"
    />
    <v-card v-if="$keycloak.hasRealmRole('root')" id="entityMerge">
      <v-card-text>
        <h2>Merge</h2>
        <p>Search for the entity you wish to merge into this one</p>
        <EntitySearch @updateEntity="updateMergeEntity" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ENTITY from "@/graphql/directory/Entity";
import UPDATE_ENTITY_ARCHIVED from "@/graphql/directory/UpdateEntityArchived";
import Address from "@/components/entity/Address";
import Company from "@/components/entity/Company";
import Contact from "@/components/entity/Contact";
import Device from "@/components/entity/Device";
import Dob from "@/components/entity/Dob";
import EntitySearch from "@/components/directory/EntitySearch";
import Fee from "@/components/entity/Fee";
import Group from "@/components/entity/Group";
import PanelNumber from "@/components/entity/PanelNumber";
import Person from "@/components/entity/Person";
import RawData from "@/components/entity/RawData";
import RelatedEmployees from "@/components/entity/RelatedEmployees";
import RelatedEmployers from "@/components/entity/RelatedEmployers";
import RelatedEntities from "@/components/entity/RelatedEntities";
import RelatedFiles from "@/components/entity/RelatedFiles";
import Roles from "@/components/entity/Roles";
import Security from "@/components/entity/Security";
import Staff from "@/components/entity/Staff";
import Uploads from "@/components/entity/Uploads";
export default {
  name: "Entity",
  apollo: {
    entity: {
      query: ENTITY,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      // result({ data }) {
      //   console.log(data.entity);
      // },
      error(error) {
        console.error(error);
        this.$router.push({ name: "home" });
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    Address,
    Company,
    Contact,
    Device,
    Dob,
    EntitySearch,
    Fee,
    Group,
    PanelNumber,
    Person,
    RawData,
    RelatedEmployees,
    RelatedEmployers,
    RelatedEntities,
    RelatedFiles,
    Roles,
    Security,
    Staff,
    Uploads
  },
  computed: {
    allowedFee() {
      return (
        this.entity.typeid == 5 ||
        this.entity.typeid == 6 ||
        this.entity.typeid == 7 ||
        this.entity.typeid == 13
      );
    },
    allowedStaff() {
      return (
        this.entity.type.staff &&
        (this.$route.params.id == this.$keycloak.tokenParsed.entityid ||
          this.$keycloak.hasRealmRole("root"))
      );
    },
    allowedStaffModule() {
      return this.entity.type.staff && this.$keycloak.hasRealmRole("root");
    },
    allowedPanelNumbers() {
      return this.entity.typeid == 8;
    },
    allowedRawData() {
      return (
        (this.entity.type.contact || this.entity.type.address > 0) &&
        this.$keycloak.hasRealmRole("root")
      );
    }
  },
  data() {
    return {
      // entity: null,
      // type: null,
      showClient: false,
      mergeId: null,
      quoteTypeId: null,
      quoteTypes: [
        {
          id: "1",
          name: "Sale"
        },
        {
          id: "2",
          name: "Purchase"
        },
        {
          id: "3",
          name: "Sale and Purchase"
        },
        {
          id: "5",
          name: "Mortgage"
        },
        {
          id: "4",
          name: "Transfer"
        },
        {
          id: "6",
          name: "Lease extension"
        }
      ],
      lastUpdated: null
    };
  },
  methods: {
    generateToc() {
      let toc = [];
      if (this.entity.type) {
        if (this.entity.type.person) {
          toc.push({ id: "personName", text: "Name", target: "#personName" });
          toc.push({
            id: "personDob",
            text: "Date of birth",
            target: "#personDob"
          });
        }
        if (this.entity.type.groups) {
          toc.push({
            id: "companyGroup",
            text: "Group",
            target: "#companyGroup"
          });
        }
        if (this.entity.type.company) {
          toc.push({
            id: "companyName",
            text: "Name",
            target: "#companyName"
          });
        }
        if (this.allowedFee) {
          toc.push({
            id: "entityFee",
            text: "Fee",
            target: "#entityFee"
          });
        }
        if (this.entity.type.address > 0) {
          toc.push({
            id: "entityAddress",
            text: "Address",
            target: "#entityAddress"
          });
        }
        if (this.entity.type.contact) {
          toc.push({
            id: "entityContact",
            text: "Contact details",
            target: "#entityContact"
          });
        }
        if (this.allowedPanelNumbers) {
          toc.push({
            id: "entityPanelNumbers",
            text: "Panel numbers",
            target: "#entityPanelNumbers"
          });
        }
        if (this.entity.uploadEntities) {
          toc.push({
            id: "entityUploads",
            text: "Uploads",
            target: "#entityUploads"
          });
        }
        if (this.entity.devices) {
          toc.push({
            id: "entityDevices",
            text: "Devices",
            target: "#entityDevices"
          });
        }
        if (
          this.entity.type.security &&
          this.$keycloak.hasRealmRole("directoryadmin")
        ) {
          toc.push({
            id: "entitySecurity",
            text: "Security",
            target: "#entitySecurity"
          });
          // toc.push({
          //   id: "entityOpenid",
          //   text: "OpenId connect",
          //   target: "#entityOpenid"
          // });
        }
        if (this.entity.type.staff) {
          if (this.allowedStaff) {
            toc.push({
              id: "staffPrinter",
              text: "Printer",
              target: "#staffPrinter"
            });
            toc.push({
              id: "staffAutorespond",
              text: "Auto respond",
              target: "#staffAutorespond"
            });
            toc.push({
              id: "staffTeams",
              text: "Teams",
              target: "#staffTeams"
            });
            toc.push({
              id: "staffSignature",
              text: "Signature",
              target: "#staffSignature"
            });
          }
          if (this.allowedStaffModule) {
            toc.push({
              id: "staffModule",
              text: "Staff",
              target: "#staffModule"
            });
          }
        }
        if (this.entity.type.employees) {
          toc.push({
            id: "entityRelatedEmployees",
            text: "Related employees",
            target: "#entityRelatedEmployees"
          });
        }
        if (this.entity.typeid == 16) {
          toc.push({
            id: "entityRelatedEmployers",
            text: "Related employers",
            target: "#entityRelatedEmployers"
          });
        }
        if (this.entity.relatedEntities) {
          toc.push({
            id: "entityRelatedEntities",
            text: "Related entities",
            target: "#entityRelatedEntities"
          });
        }
        if (this.entity.relatedFiles) {
          toc.push({
            id: "entityRelatedFiles",
            text: "Related files",
            target: "#entityRelatedFiles"
          });
        }
        if (this.entity.roles) {
          toc.push({
            id: "entityRoles",
            text: "Roles",
            target: "#entityRoles"
          });
        }
        if (this.allowedRawData) {
          toc.push({
            id: "entityRawData",
            text: "Raw data",
            target: "#entityRawData"
          });
        }
        if (this.$keycloak.hasRealmRole("root")) {
          toc.push({
            id: "entityMerge",
            text: "Merge",
            target: "#entityMerge"
          });
        }
      }
      this.$store.commit("setTableOfContents", toc);
    },
    async archiveEntity(archived) {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_ARCHIVED,
        variables: {
          id: Number(this.$route.params.id),
          archived
        }
      });
      // console.log(response.data);
      this.triggerUpdate();
    },
    generateQuote() {
      if (this.quoteTypeId) {
        this.$router.push({
          name: "quoteQuestions",
          params: {
            quoteTypeId: this.quoteTypeId
          },
          query: {
            entityId: this.$route.params.id
          }
        });
      }
    },
    updateMergeEntity(id) {
      if (confirm("Are you sure?")) {
        this.$router.push({
          name: "merge",
          params: {
            id: this.$route.params.id,
            mergeid: id
          }
        });
      }
    },
    triggerUpdate() {
      this.$apollo.queries.entity.refetch();
    }
  },
  watch: {
    entity: {
      handler() {
        if (this.entity.typeid === 3 || this.entity.typeid === 4) {
          this.showClient = true;
        }
        this.generateToc();
        this.lastUpdated = new Date();
      }
    }
  }
};
</script>

<style>
.entityRightPanel {
  float: right;
  padding: 5px;
  text-align: right;
}

.entityName {
  font-size: 2em;
}

.entityWarning {
  padding: 5px;
  border: 1px solid black;
  text-align: center;
}

.entityArchived {
  color: red;
}

.entityUnarchived {
  color: green;
}

.groupName {
  font-size: 1.5em;
}
</style>
